import {
  ADS_CAMPAIGN_CAROUSEL_FORMAT,
  IMAGE_FORMATS,
  VIDEO_FORMATS,
} from "../../utils/constants";

export const acceptedFormatsPreview = [
  ...IMAGE_FORMATS,
  ...VIDEO_FORMATS,
  ADS_CAMPAIGN_CAROUSEL_FORMAT,
];

export const getValidMediaUrls = (mediaUrls) => {
  if (!Array.isArray(mediaUrls)) {
    return [];
  }

  return mediaUrls.filter((url) => typeof url === "string" && url.trim());
};

export const buildAdMediaGalleryItem = (validUrls) => {
  if (!validUrls.length) {
    return null;
  }

  if (validUrls.length === 1) {
    return {
      id: "ad-media-preview",
      url: validUrls[0],
    };
  }

  return {
    id: "ad-media-preview-carousel",
    type: "carousel",
    isCarousel: true,
    urls: validUrls,
    url: validUrls[0],
    carouselImages: validUrls.map((url, index) => ({
      id: `ad-media-preview-${index}`,
      url,
    })),
  };
};

export const getCreativeMediaUrls = (creative = {}) => {
  if (
    creative?.isCarousel &&
    Array.isArray(creative?.urls) &&
    creative.urls.length
  ) {
    return creative.urls;
  }

  return creative?.url ? [creative.url] : [];
};

export const getCreativePreviewMediaUrls = (creative = {}) => {
  if (creative?.isCarousel && creative?.url) {
    return [creative.url];
  }

  return getCreativeMediaUrls(creative);
};
